import {withLocalization} from '@epic-core/localization';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import styled from 'styled-components';
import root from 'window-or-global';

import CTAButton from '../common/CTAButton';

import {Stack, Text} from 'epic-fortnite-react';

const StyledImageCta = styled.div`
  /* aspect-ratio: 1.5/1; */
  background-position: center;
  background-size: cover;
  display: grid;
  grid-template-rows: 1fr 1fr;
  min-height: 60vw;
  padding-block: 6rem;
  padding-inline: 2rem;

  @media (min-width: 768px) and (max-width: 1024px) {
    /* aspect-ratio: 1.5/1; */
    min-height: 90vw;
  }
`;

const StyledImageCtaContent = styled(Stack)`
  position: relative;
`;

const ImageCta = ({data}) => {
  const [isMobile, setMobile] = useState(false);
  const {title, subtitle, cta, desktopImg, mobileImg} = data;
  const bgImg = isMobile && mobileImg ? mobileImg : desktopImg;

  const isMobileCheck = React.useCallback(() => {
    const ww = root.innerWidth;
    if (ww <= 768) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, [setMobile, root]);

  React.useEffect(() => {
    isMobileCheck();
    root.addEventListener('resize', isMobileCheck, true);

    return () => {
      root.removeEventListener('resize', isMobileCheck, true);
    };
  }, [isMobileCheck, root]);

  return (
    <StyledImageCta style={{backgroundImage: `url(${bgImg})`}}>
      <StyledImageCtaContent gap="xl" justify="start">
        {title && (
          <Text
            align="center"
            as="h2"
            color={isMobile ? '#fff' : '#f5462b'}
            size={isMobile ? '2xl' : '3xl'}
            lineLength="med">
            <div dangerouslySetInnerHTML={{__html: title}}></div>
          </Text>
        )}
        {subtitle && (
          <Text align="center" as="h3" color="#fff" size={isMobile ? 'med' : 'lg'} lineLength="med">
            <div dangerouslySetInnerHTML={{__html: subtitle}}></div>
          </Text>
        )}
        {cta && <CTAButton ctaConfig={cta} theme="brightYellow" />}
      </StyledImageCtaContent>
    </StyledImageCta>
  );
};

ImageCta.propTypes = {
  data: PropTypes.object,
  mobile: PropTypes.bool,
  getMessage: PropTypes.func,
  tablet: PropTypes.bool,
};

export default withLocalization(ImageCta);
